import { render, staticRenderFns } from "./TicketPolicy.vue?vue&type=template&id=de32560e"
import script from "./TicketPolicy.vue?vue&type=script&lang=js"
export * from "./TicketPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports